import { render, staticRenderFns } from "./attRequest.vue?vue&type=template&id=2a333174&scoped=true"
import script from "./attRequest.vue?vue&type=script&lang=js"
export * from "./attRequest.vue?vue&type=script&lang=js"
import style0 from "./attRequest.vue?vue&type=style&index=0&id=2a333174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a333174",
  null
  
)

export default component.exports